import { MetricRegistry, type MetricId } from "@meta-video/contracts";

const integer = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 0 });
const decimal = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 2 });
const percent = new Intl.NumberFormat("en-GB", {
  maximumFractionDigits: 2,
  style: "percent",
});
export function NoDataCell() {
  return <span aria-label="no data">—</span>;
}

export function formatMetricValue(
  metricId: MetricId,
  value: number | null,
  currency: string,
  options: { readonly mixedCurrencyLabel?: boolean } = {},
): string | null {
  if (value === null) return null;
  switch (MetricRegistry[metricId].format) {
    case "integer":
      return integer.format(value);
    case "percent":
      return percent.format(value);
    case "currency":
      if (currency === "MIXED" && options.mixedCurrencyLabel === false) {
        return decimal.format(value);
      }
      return formatCurrency(value, currency);
    case "decimal":
      return decimal.format(value);
  }
}

export function formatCurrency(value: number, currency: string): string {
  if (currency === "MIXED") return `${decimal.format(value)} (mixed)`;
  if (!/^[A-Z]{3}$/.test(currency) || currency === "UNKNOWN") {
    return `${decimal.format(value)} ${currency}`;
  }
  try {
    return new Intl.NumberFormat("en-GB", {
      currency,
      maximumFractionDigits: 2,
      style: "currency",
    }).format(value);
  } catch {
    return `${decimal.format(value)} ${currency}`;
  }
}

export function formatDuration(seconds: number | null): string | null {
  if (seconds === null) return null;
  const rounded = Math.round(seconds);
  if (rounded < 60) return `${rounded}s`;
  const minutes = Math.floor(rounded / 60);
  const remainder = rounded % 60;
  return `${minutes}m ${String(remainder).padStart(2, "0")}s`;
}

export function formatUtcDate(isoDate: string): string {
  return isoDate;
}
